// src/components/Footer.js
import React from 'react';
import { Box, Typography, Link } from '@mui/joy';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        textAlign: 'left',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.surface',
      }}
    >
      <Typography level="body-sm">
        © {new Date().getFullYear()} {' '} 
        <Link
          href="https://negromanuel.it"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="primary"
        >
        Negro Manuel
        </Link>
        {' '}- Tutti i diritti riservati 
      </Typography>
    </Box>
  );
}
